import React from 'react';
import locales from './locales.js';

const View = props => (
  <span className="c-brand-gray-darker">
    {props.availableToEveryone ? locales.available : locales.notAvailable}
  </span>
);

export default View;
